export enum WhatsappCloudApiWarningEnum {
  LIMITATIONS_WITH_TEMPLATES = 'LIMITATIONS_WITH_TEMPLATES',
  LIMITATIONS = 'LIMITATIONS',
  TEMPORARY_LIMITATION = 'TEMPORARY_LIMITATION',
}
